import TablaConciliacion from "../../../TablaConciliacion";

function TablaRutaPortuaria() {
  return <TablaConciliacion nombreUseCase="RUTAPORTUARIA" titulo="RUTA PORTUARIA" />;
}

export default TablaRutaPortuaria;
